"use client";

import { SolutionSection } from "@/components/sections/solution";
import { solution } from "@/lib/data/services-competitive-intelligence";

export function Solution() {
  return (
    <SolutionSection
      eyebrow={solution.eyebrow}
      title={solution.title}
      intro={solution.intro}
      accent={solution.accent}
      pillarAccents={solution.pillarAccents}
      pillars={solution.pillars}
      cta={solution.cta}
    />
  );
}